import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'search',
    standalone: false
})
export class SearchPipe implements PipeTransform {
    transform(arrayOfData: any[], searchInput: string): any[] {
        if (!searchInput) {
            return arrayOfData;
        }
        searchInput = searchInput.toLowerCase();
        return arrayOfData.filter(
            x => (Object.keys(x).some(
                k =>
                    x[k] != null &&
                    x[k]
                        .toString()
                        .toLowerCase()
                        .includes(searchInput.toLowerCase())
            )
            )
        )
    }
}

